import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

/**
 * VisitTracker — fires a fire-and-forget beacon to /api/track/visit on every
 * SPA route change.  Works for both authenticated and anonymous (public) pages.
 *
 * Uses the shared axios `api` instance so the Authorization header is attached
 * automatically when the user is logged in (allowing the backend to associate
 * the visit with a user/tenant).  Errors are silently swallowed so analytics
 * never breaks the UI.
 */
const VisitTracker = () => {
  const { pathname } = useLocation();
  const lastPath = useRef(null);
  const sessionId = useRef(null);

  // Generate a per-tab session ID once
  if (!sessionId.current) {
    sessionId.current =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  }

  useEffect(() => {
    const prevPath = lastPath.current;
    if (prevPath === pathname) return;
    lastPath.current = pathname;

    const payload = {
      path: pathname,
      referrer: prevPath && prevPath !== pathname ? prevPath : (document.referrer || null),
      session_id: sessionId.current,
    };

    // Fire-and-forget — never await, never surface errors
    api.post('/api/track/visit', payload).catch(() => { /* silent */ });
  }, [pathname]);

  return null;
};

export default VisitTracker;
